<script setup lang="ts">
import router from './router'
import { computed, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useAppStore } from './modules/app/stores/app.store'
import { useViewport } from './modules/app/composables/use-viewport'
import { sv } from 'date-fns/locale'
import { setDefaultOptions } from 'date-fns'
import { ROUTE_NAMES } from './router/constants/route.constants'

import FooterBar from '@/modules/footerbar/components/FooterBar.vue'
import HeaderBar from './modules/headerbar/components/HeaderBar.vue'
import ToastMessage from './modules/toaster/components/ToastMessage.vue'
import SplashLoader from './shared/components/loader/SplashLoader.vue'
import NavigationPanel from './modules/navigation/components/NavigationPanel.vue'

const route = useRoute()
const appStore = useAppStore()

const { isDesktop } = useViewport()

setDefaultOptions({ locale: sv })

const search = computed(() => route.meta.search || null)

const isFilterEnabled = computed((): boolean => (route.meta.filterEnabled ? true : false))

watch(
  () => appStore.isMaintenanceActive,
  (newVal) => {
    if (!newVal) return
    router.push({ name: ROUTE_NAMES.MAINTENANCE })
  },
)
</script>

<template>
  <template v-if="appStore.isLoading">
    <SplashLoader :loading="appStore.isLoading" />
  </template>
  <template v-else>
    <template v-if="!appStore.isMaintenanceActive">
      <HeaderBar>
        <template #search>
          <component v-if="search" :is="search" />
        </template>
      </HeaderBar>
      <NavigationPanel v-if="isDesktop" :filter="isFilterEnabled" />
    </template>
    <RouterView />
    <ToastMessage />
    <footer>
      <FooterBar />
    </footer>
  </template>
</template>
